/* 楼盘字典-小区列表 */
<template>
  <div>
    <div class="page_top">
      <div class="title_wrapper">
        <div class="dis_flex">
          <h1 class="title_from">小区</h1>
        </div>
        <a-radio-group>
          <a-button class="" type="primary" @click="goPage('add', null)"> 新增 </a-button>
        </a-radio-group>
      </div>
      <div class="search_wrapper">
        <a-form layout="inline">
          <a-form-item label="小区名称">
            <a-input v-model="queryParam.communityFullName" :max-length="25" placeholder="小区名称" allow-clear />
          </a-form-item>
        </a-form>

        <a-radio-group>
          <a-button class="mr20" type="default" @click="getClearList"> 重置 </a-button>
          <a-button class="mr20" type="primary" @click="getList"> <!-- <a-icon type="search" /> -->查询 </a-button>
        </a-radio-group>
      </div>
    </div>

    <div class="list_wrapper">
      <!-- 数据展示 -->
      <div class="list_con">
        <div class="nodata" v-if="total <= 0">
          <no-data></no-data>
        </div>
        <div v-else>
          <a-table
            :loading="loading"
            :columns="columns"
            :data-source="list"
            :pagination="pagination"
            @change="handleChangeInTable"
            :rowKey="
              (item, index) => {
                return index
              }
            "
          >
            <template slot="operation" slot-scope="text, obj">
              <a-button class="" type="link" @click="goPage('edit', obj.id)"> 编辑 </a-button>
              <!-- <a-button class="" type="link" @click="deleteHandle(obj)">
                删除
              </a-button> -->
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { communityList, delCommunity } from '@/api/setting/community'
// import { businessDistrictList } from '@/api/setting/businessdistrict'
// import { streetList } from '@/api/setting/street'

export default {
  name: 'CommunityList',
  props: {},
  components: {},
  data() {
    return {
      total: 0,
      loading: false,
      list: [],
      queryParam: {
        communityFullName: undefined, // 小区全称	string
        communityShortName: undefined, //	小区简称	string
        pageNum: 1,
        pageSize: 10,
      },
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          // range[0] + '-' + range[1] +
          return ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      columns: [
        {
          title: '小区名称',
          align: 'center',
          dataIndex: 'communityFullName',
          key: '1',
          width: '25%',
          scopedSlots: { customRender: 'communityFullName' },
        },
        {
          title: '所属商圈',
          align: 'center',
          dataIndex: 'businessDistrictName',
          key: '2',
          width: '25%',
          scopedSlots: { customRender: 'businessDistrictName' },
        },
        {
          width: '25%',
          title: '所含街道',
          dataIndex: 'streetName',
          key: '3',
          ellipsis: false,
          scopedSlots: { customRender: 'streetName' },
        },
        {
          width: '25%',
          title: '操作',
          align: 'center',
          dataIndex: 'operation',
          key: '4',
          ellipsis: false,
          scopedSlots: { customRender: 'operation' },
        },
      ],
    }
  },
  created() {
    this.getClearList()
  },
  computed: {},
  watch: {},
  methods: {
    // 分页、排序、筛选变化时触发
    handleChangeInTable(pagination, filters, sorter) {
      this.pagination = pagination
      this.getList()
    },
    getClearList() {
      this.queryParam = {
        communityFullName: undefined, // 小区全称	string
        communityShortName: undefined, //	小区简称	string
        pageNum: 1,
        pageSize: 10,
      }
      this.getList()
    },
    getList() {
      this.loading = true
      this.queryParam.pageNum = this.pagination.current
      this.queryParam.pageSize = this.pagination.pageSize
      communityList(this.queryParam).then((response) => {
        console.log(response)
        if (response.code === 200) {
          const resData = response.data
          this.total = resData.total
          this.pagination.total = resData.total
          this.list = resData.records
        }
        this.loading = false
      })
    },
    deleteHandle(row) {
      const that = this
      const id = row.id
      const name = row.communityFullName

      that.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中小区【' + name + '】的数据',
        onOk() {
          return delCommunity(id).then(() => {
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    goPage(type, id) {
      this.$router.push({ path: '/community/' + type, query: { dataId: id } })
    },
  },
  filters: {},
}
</script>
<style lang="less" scoped>
@titleFontSize: 20px;
@titleColor: #222;
@bodyFont: 14px;
@bodyColor: #666;
@tagFont: 12px;
@tagColor: #ddd;
.mr20 {
  margin-right: 20px;
}
.page_top,
.list_wrapper {
  background: #fff;
  padding: 20px;
}
.list_wrapper {
  margin-top: 10px;
}
.title_wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  justify-content: space-between;
}
.title_from {
  font-size: @titleFontSize;
  color: @titleColor;
  font-weight: bolder;
}
.search_wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
}
.list_wrapper {
  width: 100%;
  height: auto;
  .tb_list {
    width: 100%;
    tr {
      th,
      td {
        padding: 12px 8px;
        text-align: center;
        width: 20%;
      }
      th {
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        background: #fafafa;
        border-bottom: 1px solid #e8e8e8;
        transition: background 0.3s ease;
      }
      th:nth-child(3) {
        width: 40%;
      }
      td:nth-child(3) {
        width: 98%;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    tr:hover {
      background: var(--RowHoverColor);
    }
  }
}
</style>
